"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Youtube = function Youtube(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M35.434 10.25a228.514 228.514 0 0 0-22.868 0c-5.85.414-6.54 4.076-6.584 13.714.044 9.62.727 13.3 6.584 13.714a228.484 228.484 0 0 0 22.868 0c5.85-.414 6.54-4.076 6.584-13.714-.044-9.62-.728-13.3-6.584-13.714zM20 30V18l11 6z" })
	);
};

exports.default = Youtube;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Youtube/index.js
// module id = 180
// module chunks = 0